// extracted by mini-css-extract-plugin
export var boxItems = "_as-1";
export var boxItemsLg = "_as-2";
export var button = "_as-7";
export var buttonHoverless = "_as-9";
export var buttonLg = "_as-8";
export var filterGroupBox = "_as-0";
export var icon = "_as-3";
export var iconSecondary = "_as-6";
export var iconWrapper = "_as-4";
export var iconWrapperLg = "_as-5";
export var truncatedLabel = "_as-a";